import { useState } from "react";
import { toast } from "sonner";
import { PortalHeading } from "@/pages/portal/PortalLayout";
import { Input } from "@/components/ui/input";
import { Switch } from "@/components/ui/switch";
import { useAuth } from "@/context/AuthContext";
import { useFetch } from "@/hooks/useFetch";
import { api, errMsg } from "@/lib/api";
import { CATEGORY_TITLE } from "@/lib/constants";

const Row = ({ s, reload, canEdit }) => {
  const [p, setP] = useState(s.pricing || { type: "assessment" });
  const save = async (extra = {}) => {
    try { await api.patch(`/admin/services/${s.slug}`, { pricing: p, ...extra }); toast.success(`${s.title} saved`); reload(); }
    catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <div className="rounded-2xl bg-white p-4 grid md:grid-cols-12 gap-3 items-center" data-testid={`admin-service-${s.slug}`}>
      <div className="md:col-span-4"><p className="font-semibold">{s.title}</p><p className="text-xs text-[#56585E]">{CATEGORY_TITLE[s.category]}</p></div>
      <select disabled={!canEdit} value={p.type} onChange={(e) => setP({ type: e.target.value })} className="md:col-span-2 rounded-md border px-2 py-2 text-sm" data-testid={`admin-service-type-${s.slug}`}>
        <option value="instant">Instant</option><option value="range">Range</option><option value="assessment">Assessment</option>
      </select>
      <div className="md:col-span-3 flex gap-2">
        {p.type === "instant" && <Input disabled={!canEdit} value={p.unit_price || ""} onChange={(e) => setP({ ...p, unit_price: e.target.value })} placeholder="Base USD" data-testid={`admin-service-price-${s.slug}`} />}
        {p.type === "range" && <><Input disabled={!canEdit} value={p.min_price || ""} onChange={(e) => setP({ ...p, min_price: e.target.value })} placeholder="Min" data-testid={`admin-service-min-${s.slug}`} />
          <Input disabled={!canEdit} value={p.max_price || ""} onChange={(e) => setP({ ...p, max_price: e.target.value })} placeholder="Max" data-testid={`admin-service-max-${s.slug}`} /></>}
      </div>
      <label className="md:col-span-2 flex items-center gap-2 text-xs"><Switch disabled={!canEdit} checked={s.published} onCheckedChange={(v) => save({ published: v })} data-testid={`admin-service-published-${s.slug}`} />Published</label>
      <button disabled={!canEdit} onClick={() => save()} data-testid={`admin-service-save-${s.slug}`} className="md:col-span-1 rounded-full bg-[#020165] text-white px-3 py-1.5 text-sm font-semibold disabled:opacity-40">Save</button>
    </div>
  );
};

export default function AdminServices() {
  const { isAdmin } = useAuth();
  const { data, reload } = useFetch("/admin/services");
  return (
    <div data-testid="admin-services">
      <PortalHeading title="Price editor" sub={isAdmin ? "Base prices before vehicle-size uplift and add-ons. All figures USD." : "Only owners and workshop managers can change prices."} />
      <div className="space-y-2">{data?.services.map((s) => <Row key={s.slug} s={s} reload={reload} canEdit={isAdmin} />)}</div>
    </div>
  );
}
